import { CardAtoms } from "./atoms";
import { CardMolecules } from "./molecules";
import { CardOrganisms } from "./organisms";

export const CardComponents = [
  ...CardAtoms,
  ...CardMolecules,
  ...CardOrganisms,
];
